
export const langPath = (lang: string) => {
  return lang === "ja" ? "" : `/${lang}`;
}